import { render, staticRenderFns } from "./manageOrderList.vue?vue&type=template&id=06216d5d&"
import script from "./manageOrderList.vue?vue&type=script&lang=js&"
export * from "./manageOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports